/*
 * @Author: 小周
 * @Date: 2023-09-07 11:06:58
 * @LastEditTime: 2023-09-07 11:08:11
 * @LastEditors: MrZHLF 480970024@qq.com
 * @Description: 统一处理分享
 */

import { appShare } from './appShare'
import { H5WeChat_init } from './wxShare'
import { isCheckApp } from '@/utils/index'

/**
 *
 * @param { string } shareTitle 标题
 * @param { string } shareDesc 分享描述
 * @param { string } shareLink 分享回调地址
 * @param { string } shareImg  分享logo
 * @description 统一封装处理
 * @author 小周
 *
 */

export function appWxShare(info = {}) {
  if (isCheckApp()) {
    window.getShareUrl = function () {
      appShare(info)
      return true
    }
  } else {
    H5WeChat_init(info)
  }
}
